module.exports = __webpack_public_path__ + "static/media/cam_4-mobile.1034bd84.webp";